module.exports = __webpack_public_path__ + "static/media/mapBusLess.77167158.png";